import React from 'react';
import { Link } from 'react-router-dom';
import Panel from '@/components/ui/Panel';
import { AlertTriangle, Home } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  const iconStyle: React.CSSProperties = {
    color: '#f472b6',
    margin: '0 auto 1.5rem',
    display: 'block',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: '#dbeafe',
    marginBottom: '1rem',
  };

  const subtitleStyle: React.CSSProperties = {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#94a3b8',
    marginBottom: '1.5rem',
  };

  const descriptionStyle: React.CSSProperties = {
    color: '#94a3b8',
    marginBottom: '2rem',
    lineHeight: '1.6',
  };

  const buttonStyle: React.CSSProperties = {
    background: 'linear-gradient(to right, #2563eb, #7c3aed)',
    color: 'white',
    padding: '0.75rem 1.5rem',
    borderRadius: '0.5rem',
    border: 'none',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    textDecoration: 'none',
  };

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-150px)] animate-fadeIn">
      <Panel 
        style={{ 
          textAlign: 'center', 
          maxWidth: '32rem',
          width: '100%',
        }}
        padding="lg"
        border={true}
      >
        <AlertTriangle size={64} style={iconStyle} />
        <h1 style={titleStyle}>404</h1>
        <h2 style={subtitleStyle}>Page Not Found</h2>
        <p style={descriptionStyle}>
          Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
        </p>
        <Link
          to="/"
          style={buttonStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'linear-gradient(to right, #1d4ed8, #6d28d9)';
            e.currentTarget.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'linear-gradient(to right, #2563eb, #7c3aed)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <Home size={20} />
          Go to Homepage
        </Link>
      </Panel>
    </div>
  );
};

// Extend Button to accept 'component' prop for Link
// This can be moved to a .d.ts file or kept here if Button.tsx doesn't export its own extended types
declare module '@/components/ui/Button' {
  interface ButtonProps {
    component?: React.ElementType;
    to?: string; // For Link component
  }
}

export default NotFoundPage; 